import * as i0 from '@angular/core';
import * as i1 from './aws-amplify-ionic-module';
import * as i2 from '@angular/common';
import * as i3 from '@angular/forms';
import * as i4 from './components/authenticator/authenticator/authenticator.component.ionic';
import * as i5 from './components/authenticator/confirm-sign-in-component/confirm-sign-in-component.ionic';
import * as i6 from './components/authenticator/confirm-sign-up-component/confirm-sign-up.component.ionic';
import * as i7 from './components/authenticator/forgot-password-component/forgot-password.component.ionic';
import * as i8 from './components/authenticator/greeting-component/greeting.component.ionic';
import * as i9 from './components/authenticator/sign-in-component/sign-in.component.ionic';
import * as i10 from './components/authenticator/sign-up-component/sign-up.component.ionic';
import * as i11 from './components/authenticator/username-field-component/username-field.component.ionic';
import * as i12 from './components/authenticator/phone-field-component/phone-field.component.ionic';
import * as i13 from './components/authenticator/require-new-password-component/require-new-password.component.ionic';
import * as i14 from './components/storage/photo-picker-component/photo-picker.component.ionic';
import * as i15 from './components/storage/s3-album-component/s3-album.component.ionic';
import * as i16 from './components/storage/s3-image-component/s3-image.component.ionic';
import * as i17 from './components/interactions/chatbot/chatbot.component.ionic';
import * as i18 from './components/xr/sumerian-scene-component/sumerian-scene.component.ionic';
import * as i19 from './components/xr/sumerian-scene-component/sumerian-scene-loading.component.ionic';
export const AmplifyIonicModuleNgFactory:i0.NgModuleFactory<i1.AmplifyIonicModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.ɵangular_packages_forms_forms_bg = (<any>(null as any));
var _decl0_12:i3.NgSelectOption = (<any>(null as any));
var _decl0_13:i3.ɵangular_packages_forms_forms_r = (<any>(null as any));
var _decl0_14:i3.DefaultValueAccessor = (<any>(null as any));
var _decl0_15:i3.ɵangular_packages_forms_forms_bd = (<any>(null as any));
var _decl0_16:i3.ɵangular_packages_forms_forms_bf = (<any>(null as any));
var _decl0_17:i3.CheckboxControlValueAccessor = (<any>(null as any));
var _decl0_18:i3.SelectControlValueAccessor = (<any>(null as any));
var _decl0_19:i3.SelectMultipleControlValueAccessor = (<any>(null as any));
var _decl0_20:i3.RadioControlValueAccessor = (<any>(null as any));
var _decl0_21:i3.NgControlStatus = (<any>(null as any));
var _decl0_22:i3.NgControlStatusGroup = (<any>(null as any));
var _decl0_23:i3.RequiredValidator = (<any>(null as any));
var _decl0_24:i3.MinLengthValidator = (<any>(null as any));
var _decl0_25:i3.MaxLengthValidator = (<any>(null as any));
var _decl0_26:i3.PatternValidator = (<any>(null as any));
var _decl0_27:i3.CheckboxRequiredValidator = (<any>(null as any));
var _decl0_28:i3.EmailValidator = (<any>(null as any));
var _decl0_29:i3.NgModel = (<any>(null as any));
var _decl0_30:i3.NgModelGroup = (<any>(null as any));
var _decl0_31:i3.NgForm = (<any>(null as any));
var _decl0_32:i4.AuthenticatorIonicComponent = (<any>(null as any));
var _decl0_33:i5.ConfirmSignInComponentIonic = (<any>(null as any));
var _decl0_34:i6.ConfirmSignUpComponentIonic = (<any>(null as any));
var _decl0_35:i7.ForgotPasswordComponentIonic = (<any>(null as any));
var _decl0_36:i8.GreetingComponentIonic = (<any>(null as any));
var _decl0_37:i9.SignInComponentIonic = (<any>(null as any));
var _decl0_38:i10.SignUpComponentIonic = (<any>(null as any));
var _decl0_39:i11.UsernameFieldComponentIonic = (<any>(null as any));
var _decl0_40:i12.PhoneFieldComponentIonic = (<any>(null as any));
var _decl0_41:i13.RequireNewPasswordComponentIonic = (<any>(null as any));
var _decl0_42:i14.PhotoPickerIonicComponent = (<any>(null as any));
var _decl0_43:i15.S3AlbumComponentIonic = (<any>(null as any));
var _decl0_44:i16.S3ImageComponentIonic = (<any>(null as any));
var _decl0_45:i17.ChatbotComponentIonic = (<any>(null as any));
var _decl0_46:i18.SumerianSceneComponentIonic = (<any>(null as any));
var _decl0_47:i19.SumerianSceneLoadingComponentIonic = (<any>(null as any));
var _decl0_48:i2.AsyncPipe = (<any>(null as any));
var _decl0_49:i2.UpperCasePipe = (<any>(null as any));
var _decl0_50:i2.LowerCasePipe = (<any>(null as any));
var _decl0_51:i2.JsonPipe = (<any>(null as any));
var _decl0_52:i2.SlicePipe = (<any>(null as any));
var _decl0_53:i2.DecimalPipe = (<any>(null as any));
var _decl0_54:i2.PercentPipe = (<any>(null as any));
var _decl0_55:i2.TitleCasePipe = (<any>(null as any));
var _decl0_56:i2.CurrencyPipe = (<any>(null as any));
var _decl0_57:i2.DatePipe = (<any>(null as any));
var _decl0_58:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_59:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_60:i2.CommonModule = (<any>(null as any));
var _decl0_61:i3.FormsModule = (<any>(null as any));
var _decl0_62:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_63:i0.ElementRef = (<any>(null as any));
function _View_AuthenticatorIonicComponent_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_AuthenticatorIonicComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = !_decl0_32.shouldHide('SignIn');
  currVal_0;
  const currVal_1:any = !_decl0_32.shouldHide('SignUp');
  currVal_1;
  const currVal_2:any = !_decl0_32.shouldHide('ConfirmSignUp');
  currVal_2;
  const currVal_3:any = !_decl0_32.shouldHide('ConfirmSignIn');
  currVal_3;
  const currVal_4:any = !_decl0_32.shouldHide('ForgotPassword');
  currVal_4;
  const currVal_5:any = !_decl0_32.shouldHide('Greetings');
  currVal_5;
  const currVal_6:any = !_decl0_32.shouldHide('RequireNewPassword');
  currVal_6;
}
function _View_ConfirmSignInComponentIonic_Host_2_0():void {
  var _any:any = (null as any);
}
function _View_ConfirmSignInComponentIonic_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_33._show;
  currVal_0;
}
function _View_ConfirmSignUpComponentIonic_Host_3_0():void {
  var _any:any = (null as any);
}
function _View_ConfirmSignUpComponentIonic_3_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_34._show;
  currVal_0;
}
function _View_ForgotPasswordComponentIonic_Host_4_0():void {
  var _any:any = (null as any);
}
function _View_ForgotPasswordComponentIonic_4_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_35._show;
  currVal_0;
}
function _View_GreetingComponentIonic_Host_5_0():void {
  var _any:any = (null as any);
}
function _View_GreetingComponentIonic_5_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_36.signedIn;
  currVal_0;
}
function _View_SignInComponentIonic_Host_6_0():void {
  var _any:any = (null as any);
}
function _View_SignInComponentIonic_6_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_37._show;
  currVal_0;
}
function _View_SignUpComponentIonic_Host_7_0():void {
  var _any:any = (null as any);
}
function _View_SignUpComponentIonic_7_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_38._show;
  currVal_0;
}
function _View_UsernameFieldComponentIonic_Host_8_0():void {
  var _any:any = (null as any);
}
function _View_UsernameFieldComponentIonic_8_0():void {
  var _any:any = (null as any);
  const currVal_0:any = (_decl0_39._usernameAttributes === 'email');
  currVal_0;
  const currVal_1:any = (_decl0_39._usernameAttributes === 'phone_number');
  currVal_1;
  const currVal_2:any = ((_decl0_39._usernameAttributes !== 'email') && (_decl0_39._usernameAttributes !== 'phone_number'));
  currVal_2;
}
function _View_PhoneFieldComponentIonic_Host_9_0():void {
  var _any:any = (null as any);
}
function _View_PhoneFieldComponentIonic_9_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_40.amplifyService.i18n().get(_decl0_40._label);
  currVal_0;
  const currVal_1:any = _decl0_40._required;
  currVal_1;
  const currVal_2:any = _decl0_40._country_code;
  currVal_2;
  const currVal_3:any = _decl0_40._countries;
  currVal_3;
  const currVal_4:any = i0.ɵinlineInterpolate(1,'',_decl0_40.amplifyService.i18n().get(_decl0_40.getPlaceholder()),
      '');
  currVal_4;
  const pd_5:any = ((<any>_decl0_40.setCountryCode(_any.target.value)) !== false);
  const pd_6:any = ((<any>_decl0_40.setLocalPhoneNumber(_any.target.value)) !== false);
}
function _View_RequireNewPasswordComponentIonic_Host_10_0():void {
  var _any:any = (null as any);
}
function _View_RequireNewPasswordComponentIonic_10_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_41._show;
  currVal_0;
}
function _View_PhotoPickerIonicComponent_Host_11_0():void {
  var _any:any = (null as any);
}
function _View_PhotoPickerIonicComponent_11_0():void {
  var _any:any = (null as any);
  const currVal_0:any = !_decl0_42.hasPhoto;
  currVal_0;
  const currVal_1:any = _decl0_42.hasPhoto;
  currVal_1;
  const currVal_2:any = _decl0_42.hasPhoto;
  currVal_2;
  const currVal_3:any = _decl0_42.errorMessage;
  currVal_3;
  const pd_4:any = ((<any>_decl0_42.pick(_any)) !== false);
}
function _View_S3AlbumComponentIonic_Host_12_0():void {
  var _any:any = (null as any);
}
function _View_S3AlbumComponentIonic_12_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_43.list;
  currVal_0;
}
function _View_S3ImageComponentIonic_Host_13_0():void {
  var _any:any = (null as any);
}
function _View_S3ImageComponentIonic_13_0():void {
  var _any:any = (null as any);
  const currVal_0:any = i0.ɵinlineInterpolate(1,'',_decl0_44.url,'');
  currVal_0;
  const pd_1:any = ((<any>_decl0_44.onImageClicked()) !== false);
}
function _View_ChatbotComponentIonic_Host_14_0():void {
  var _any:any = (null as any);
}
function _View_ChatbotComponentIonic_14_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_45.chatTitle;
  currVal_0;
  const currVal_1:any = _decl0_45.messages;
  currVal_1;
  const currVal_2:any = _decl0_45.textEnabled;
  currVal_2;
  const currVal_3:any = !_decl0_45.textEnabled;
  currVal_3;
  const currVal_4:any = _decl0_45.voiceEnabled;
  currVal_4;
  const currVal_5:any = _decl0_45.textEnabled;
  currVal_5;
}
function _View_SumerianSceneComponentIonic_Host_15_0():void {
  var _any:any = (null as any);
}
function _View_SumerianSceneComponentIonic_15_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_46.amplifyUI.sumerianSceneContainer;
  currVal_0;
  const currVal_1:any = _decl0_46.amplifyUI.sumerianScene;
  currVal_1;
  const currVal_2:any = _decl0_46.loading;
  currVal_2;
  const currVal_3:any = !_decl0_46.loading;
  currVal_3;
}
function _View_SumerianSceneLoadingComponentIonic_Host_16_0():void {
  var _any:any = (null as any);
}
function _View_SumerianSceneLoadingComponentIonic_16_0():void {
  var _any:any = (null as any);
  const currVal_0:any = i0.ɵinlineInterpolate(1,'',_decl0_47.AmplifyUI.loadingOverlay,
      '');
  currVal_0;
  const currVal_1:any = i0.ɵinlineInterpolate(1,'',_decl0_47.AmplifyUI.loadingContainer,
      '');
  currVal_1;
  const currVal_2:any = i0.ɵinlineInterpolate(1,'',_decl0_47.AmplifyUI.loadingLogo,
      '');
  currVal_2;
  const currVal_3:any = i0.ɵinlineInterpolate(1,'',_decl0_47.AmplifyUI.loadingSceneName,
      '');
  currVal_3;
  const currVal_4:any = _decl0_47.sceneName;
  currVal_4;
  const currVal_5:any = _decl0_47.sceneError;
  currVal_5;
  const currVal_6:any = !_decl0_47.sceneError;
  currVal_6;
}
